import { fetchSearchV1, type SearchV1Request } from '@/features/search/api/searchV1'
import { addToWishlist, createWishlist } from '@/features/wishlist/api/wishlist'

/** Gift ideas through the catalogue search (no gift endpoint yet, BE-153). */
export async function fetchGiftQuizIdeas(request: SearchV1Request, signal?: AbortSignal) {
  return fetchSearchV1(request, { signal })
}

/**
 * Save to list: a new list named after the recipient, then every idea into it — the API
 * has no batch add. A taken name gets the date appended once.
 */
export async function saveGiftQuizIdeas(name: string, variantIds: number[]): Promise<number> {
  let list: { id: number }
  try {
    list = (await createWishlist(name)).data as { id: number }
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response?.status
    if (status !== 409 && status !== 422) throw error
    list = (await createWishlist(`${name} · ${new Date().toLocaleDateString()}`)).data as { id: number }
  }
  await Promise.all(variantIds.map((variantId) => addToWishlist(list.id, variantId)))
  return list.id
}
